<!--
	Marker-SPALTEN für gruppierte mat-tables (Kopfzeile · „Alle anzeigen" · Add-Zeile). Die Zellen
	werden NICHT hier gerendert, sondern zur Laufzeit via `addColumnDef` in die mat-table des Consumers
	eingeklinkt (Muster: MatTextColumn). Den Zellinhalt liefert der Consumer als projiziertes
	<ng-template>; die Union-Verengung passiert hier einmalig über die `*Context`-Helfer.

	Die drei zugehörigen `*matRowDef`s bleiben BEWUSST im Consumer-Template (ARA_GROUP_ROW_DEFS): einer
	Kind-View lassen sich Spalten sauber unterschieben, `when`-Row-Defs aber nicht (der Daten-Differ der
	Tabelle rendert sonst, bevor die Registrierung greift). Spalten-`name` wird in ngOnInit imperativ
	gesetzt, nicht per Binding — in dieser Kind-View greift die Bindung erst nach dem ersten Content-Check.
-->
<ng-container #headerColDef matColumnDef>
	<td *matCellDef="let row" mat-cell [attr.colspan]="columnCount()" class="ara-table-group-cell">
		<ng-container *ngTemplateOutlet="headerCell(); context: headerContext(row)"></ng-container>
	</td>
</ng-container>

<ng-container #moreColDef matColumnDef>
	<td *matCellDef="let row" mat-cell [attr.colspan]="columnCount()">
		<ng-container *ngTemplateOutlet="moreCell(); context: moreContext(row)"></ng-container>
	</td>
</ng-container>

<ng-container #addColDef matColumnDef>
	<td *matCellDef="let row" mat-cell [attr.colspan]="columnCount()">
		<ng-container *ngTemplateOutlet="addCell() ?? null; context: addContext(row)"></ng-container>
	</td>
</ng-container>
